<template>
  <router-view />
</template>

<script>

export default {
  name: "App",
  errorCaptured(err) {
    if (__MAIN_SYSTEM__) {
      if (err instanceof CmnMis.Error.UnAuthenticationError) {
        CmnMis.Func.JumpToLoginPage();
        return false;
      }
    }
  },
};
</script>

<style>
body,
html {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
body {
  margin: 0;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.cg-auto-scroll::-webkit-scrollbar-corner {
  background: rgba(105, 105, 105, 0);
}

.cg-auto-scroll::-webkit-scrollbar-track {
  background: rgba(105, 105, 105, 0);
}

.cg-auto-scroll::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  border-radius: 3px;
  position: absolute;
}

.cg-auto-scroll::-webkit-scrollbar-thumb {
  background: rgba(238, 238, 238, 0.5);
  display: none;
}

.cg-auto-scroll:hover::-webkit-scrollbar-thumb {
  display: inline-block;
}

.cg-list-toolbar {
  margin-bottom: 16px;
  display: flex;
}

.cg-list-toolbar .cg-list-toolbar-left {
  flex: 1;
}

.cg-list-toolbar-left .ant-btn {
  margin-right: 10px;
}

.cg-list-footer {
  margin-top: 16px;
  display: flex;
}

.cg-list-footer .cg-list-footer-left {
  flex: 1;
}

.cg-list-footer-right .ant-btn {
  margin-left: 10px;
}

.cg-edit-footer {
  display: flex;
  padding: 16px 0;
  background-color: white;
}

.cg-edit-footer .cg-edit-footer-left {
  flex: 1;
}

.cg-edit-footer-right .ant-btn {
  margin-left: 10px;
}
</style>
